import { IconButton, Tooltip } from '@mui/material'
import { useState } from 'react'
import AutorenewIcon from '@mui/icons-material/Autorenew'
import PauseIcon from '@mui/icons-material/Pause'

const ReportRefreshControls = ({ 
  autoRefresh, 
  onToggleAutoRefresh, 
  onManualRefresh, 
  isLoading = false 
}) => {
  const [showTooltip, setShowTooltip] = useState(false)

  const handleToggle = () => {
    onToggleAutoRefresh()
    setShowTooltip(true)
    setTimeout(() => setShowTooltip(false), 2000)
  }

  return (
    <Tooltip 
      title={showTooltip ? (autoRefresh ? 'Auto Refresh Disabled (All Reports)' : 'Auto Refresh Enabled (All Reports)') : (autoRefresh ? 'Auto Refresh On - Click to disable all reports' : 'Auto Refresh Off - Click to enable all reports')}
      placement="top" 
      arrow
      open={showTooltip || undefined}
    >
      <IconButton
        onClick={handleToggle}
        disabled={isLoading}
        size="small"
        color={autoRefresh ? 'primary' : 'default'}
        sx={{
          animation: autoRefresh ? 'spin 2s linear infinite' : 'none',
          '@keyframes spin': {
            '0%': {
              transform: 'rotate(0deg)',
            },
            '100%': {
              transform: 'rotate(360deg)',
            },
          },
        }}
      >
        {autoRefresh ? <AutorenewIcon /> : <PauseIcon />}
      </IconButton>
    </Tooltip>
  )
}

export default ReportRefreshControls